import React,{useState} from "react";
import { Row, Col } from "react-bootstrap";

import styled from "styled-components";
import Connect from "./Connect";
import Connected from "./Connected";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 150px 0 90px 0;
  background: #000;

  .text {
    padding: 0;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    color: #ffff;
    padding: 8px 0;
    line-height: 100%;
    font-weight: 700;

    text-align: center;
  }
  .image {
    width: 100%;
  }
  .button {
    color: #000;
    background-color: #fff;
    font-size: 22px;
    border-radius: 999px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 32px;
    min-width: 144px;
    transition: background-color 0.15s linear;
    margin-top: 40px;
    font-weight: 700;
  }

  @media only screen and (max-width: 1199px) {
    .button {
      margin-top: 15px;
    }
  }
  @media only screen and (max-width: 1014px) {
    .button {
      margin-top: 10px;
      font-size: 18px;
    }
  }
  @media only screen and (max-width: 991px) {
    .button {
      font-size: 18px;
      margin-top: 35px;
    }
  }

  @media only screen and (max-width: 1199px) {
    .text {
      font-size: 22px;
    }
  }

  @media only screen and (max-width: 767px) {
    .text {
      text-align: center;
    }
  }
`;
const HeroSection = () => {
  const [isConnected,setConnected]=useState(false);
  const onLogin= ()=>{
      setConnected(true)
  }
 const  onLogout = ()=>{
  setConnected(false)
 }
  return (
    <Wrapper>
      <Col xs={11}>
        <Row className="align-items-center ">
          <Col sm={10} md={8} lg={6} xxl={6}>
            {" "}
            <img
              src="./images/hero.gif"
              alt="#"
              className="image d-none d-lg-flex"
            />
            <img
              src="./images/mobilehero.gif"
              alt="#"
              className="image d-lg-none"
            />
          </Col>
          <Col
            lg={6}
            xxl={5}
            className="d-flex flex-column align-items-center justify-content-center"
          >
            <div className="socialContainer mt-5">
              <p className="text"> Mint 3 Moonbirds and Get 1 Free</p>
              <p className="text ">Your Moonbirds are waiting for you</p>{" "}
            </div>
            {!isConnected && <Connect onLogin={onLogin} onlogout={onLogout}/>}
            {
              isConnected && (
                <Connected/>
              )
            }
            
          </Col>
        </Row>
      </Col>
    </Wrapper>
  );
};
export default HeroSection;
